import DomainService from '@/services/DomainService'

const state = {
  edit: null,
  data: []
}

const mutations = {
  SET_DATA (state, data) {
    state.data = data
  },
  SET_EDIT (state, edit) {
    state.edit = edit
  },
  STORE (state, data) {
    state.data.push(data)
  },
  UPDATE (state, domain) {
    state.data = state.data.map(_domain => {
      return domain.id === _domain.id ? domain : _domain
    })
  },
  DESTROY (state, domain) {
    state.data = state.data.filter(_domain => {
      return domain.id !== _domain.id
    })

    if (state.data[0]) {
      state.id = state.data[0].id
    }
  }
}

const actions = {
  async index ({ commit }, query) {
    const data = await DomainService.index(query)
    commit('SET_DATA', data)
    return data
  },
  async show ({ commit }, id) {
    const data = await DomainService.show(id)
    commit('UPDATE', data)
    return data
  },
  async store ({ commit }, data) {
    const store = await DomainService.store(data)
    commit('STORE', store)
    return store
  },
  async update ({ commit }, { id, data }) {
    const update = await DomainService.update(id, data)
    commit('UPDATE', update)
    return update
  },
  async verify ({ commit }, id) {
    const update = await DomainService.show(`${id}/verify`)
    commit('UPDATE', update)
    return update
  },
  async destroy ({ commit }, { id }) {
    const destroy = await DomainService.destroy(id)
    commit('DESTROY', destroy)
    return destroy
  }
}

const getters = {
  getVerified (state) {
    return state.data.filter(item => item.verified)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
